var _defs, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_filled_no_stroke",
    d: "M32.306 6.512H10.212a6.218 6.218 0 00-6.21 6.211V24.8a6.218 6.218 0 006.21 6.211h2.593v4.45a1.512 1.512 0 001.003 1.417c.175.062.319.114.495.114.755 0 2.094-.942 9.001-5.981h9.002a6.218 6.218 0 006.211-6.211V12.723a6.218 6.218 0 00-6.211-6.211zm-2.027 10.33H11.866a1.829 1.829 0 010-3.656h18.412a1.829 1.829 0 010 3.656zm-5.329 7.522H11.866a1.829 1.829 0 010-3.656H24.95a1.829 1.829 0 010 3.656z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 31.193,
    cy: 22.536,
    r: 1.68
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatFilled);
export default __webpack_public_path__ + "static/media/chatFilled.2acbc7fcb387a044f372bbc25c9c0e7c.svg";
export { ForwardRef as ReactComponent };